// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fa1486d9","396":"1b335b4a","453":"09bd2023","455":"a23f9b9d","977":"550aa7e9"}[chunkId] + ".chunk.js";
};